import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize('UA-106385343-1');

const limiter = {};

/**
 * TODO: this is breaking all links on PCs.
 */

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    // Avoid Double Tracking
    limiter[page] = limiter[page] ? limiter[page] + 1 : 1;
    if (limiter[page] > 1) return;
    setTimeout(() => {
      limiter[page] = 0;
    }, 1000); // Fix this hacky code to stop double views.

    // Only Track Global Site.
    if (window.location.host.indexOf('theculinistas.com') <= -1) {
      console.log('\n\n ------- TRACK -------');
      console.log(page);
      console.log(options);
      console.log(limiter[page]);
      console.log('---------------------');
      return;
    }

    GoogleAnalytics.set({
      page,
      ...options
    });
    GoogleAnalytics.pageview(page);
  };

  // eslint-disable-next-line
  const HOC = class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loads: 0
      };
    }

    componentDidMount() {
      // eslint-disable-next-line
      const page = this.props.location.pathname + this.props.location.search;
      trackPage(page);

      this.setState({ loads: this.state.loads + 1 });
    }

    componentDidUpdate(prevProps) {
      const currentPage =
        prevProps.location.pathname + prevProps.location.search;
      const nextPage =
        this.props.location.pathname + this.props.location.search;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;



// WEBPACK FOOTER //
// ./src/components/withTracker.js